<template>
  <section class="home-hero">
    <div class="hero-media">
      <img
        :src="heroImage"
        :alt="t('home.hero.title')"
        class="hero-image"
      />
    </div>
    <div class="hero-content">
      <div class="hero-inner">
        <p class="hero-eyebrow">{{ t('home.hero.eyebrow') }}</p>
        <h1 class="hero-title">{{ t('home.hero.title') }}</h1>
        <p class="hero-subtitle">{{ t('home.hero.subtitle') }}</p>
        <div class="hero-actions">
          <button class="btn btn-primary" type="button" @click="scrollToGooval">
            {{ t('home.hero.ctaGooval') }}
          </button>
          <button class="btn btn-secondary" type="button" @click="scrollToContact">
            {{ t('home.hero.ctaContact') }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useTranslation } from '@/utils/i18n'

const heroImage = require('@/assets/img/home/hero.png')

export default {
  name: 'HomeHero',
  setup() {
    const { t } = useTranslation()

    const scrollToGooval = () => {
      const target = document.getElementById('gooval-product')
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }

    const scrollToContact = () => {
      const target = document.getElementById('contact-us')
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }

    return {
      t,
      heroImage,
      scrollToGooval,
      scrollToContact
    }
  }
}
</script>

<style lang="scss" scoped>
.home-hero {
  position: relative;
  width: 100%;
  min-height: clamp(420px, 72vh, 640px);
  overflow: hidden;
}

.hero-media {
  position: absolute;
  inset: 0;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.hero-content {
  position: relative;
  z-index: 2;
  min-height: inherit;
  display: flex;
  align-items: center;
  padding: 120px 24px 80px;
  background: linear-gradient(90deg, rgba(6, 28, 48, 0.88) 0%, rgba(6, 28, 48, 0.55) 55%, rgba(6, 28, 48, 0.2) 100%);
}

.hero-inner {
  max-width: 760px;
  color: #ffffff;
}

.hero-eyebrow {
  margin: 0 0 16px;
  font-size: 13px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.78);
  font-family: 'Aileron-Regular', sans-serif;
}

.hero-title {
  margin: 0 0 20px;
  font-size: clamp(32px, 5vw, 52px);
  line-height: 1.12;
  font-weight: 700;
  font-family: 'Aileron-Bold', sans-serif;
}

.hero-subtitle {
  margin: 0 0 32px;
  max-width: 620px;
  font-size: clamp(16px, 2.2vw, 20px);
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.9);
  font-family: 'Aileron-Regular', sans-serif;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.btn {
  padding: 12px 22px;
  font-size: 15px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  font-family: 'Aileron-Bold', sans-serif;
}

.btn-primary {
  background: linear-gradient(135deg, #1a7fb0 0%, #0f4c81 100%);
  color: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 76, 129, 0.28);
}

.btn-primary:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, #2196c4 0%, #125a94 100%);
  box-shadow: 0 12px 28px rgba(15, 76, 129, 0.36);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.42);
  backdrop-filter: blur(8px);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  background: rgba(26, 127, 176, 0.18);
  border-color: rgba(122, 196, 226, 0.75);
}

@media (max-width: 768px) {
  .hero-content {
    padding: 100px 20px 64px;
    background: linear-gradient(180deg, rgba(6, 28, 48, 0.9) 0%, rgba(6, 28, 48, 0.72) 100%);
  }

  .hero-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .btn {
    width: 100%;
  }
}
</style>
